import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-tailwind/react";

import "./index.css";
import App from "./App";
import './i18n/i18n';


import { AuthProvider } from "./contexts/AuthContext";
import { MaterialTailwindControllerProvider } from "./contexts/MaterialContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <ThemeProvider>
        <MaterialTailwindControllerProvider>
          <App />
        </MaterialTailwindControllerProvider>
      </ThemeProvider>
    </AuthProvider>
  </BrowserRouter>
);
